import type { FunctionComponent, SVGProps } from 'react';
import type React from 'react';

export enum intakeConfigBlock {
  physical = 'physical',
  typeofcare = 'typeofcare',
  emr = 'emr',
  assignpt = 'assignpt',
  startRtm = 'startrtm',
  poa = 'poa',
  address = 'address',
  surgery = 'surgery',
  o_and_p = 'o_and_p',
}

export const intakeSectionConfig = {
  clinical: [intakeConfigBlock.physical, intakeConfigBlock.surgery],
  administrative: [intakeConfigBlock.typeofcare, intakeConfigBlock.emr, intakeConfigBlock.startRtm],
  generalSettings: [intakeConfigBlock.assignpt, intakeConfigBlock.poa],
};

export type IntakeBlocksType = intakeConfigBlock;
export interface useIntakeBlockToggleValue {
  isOn(value: IntakeBlocksType): boolean;
  isRequired(value: IntakeBlocksType): boolean;
}

export enum addedUserByTypeEnum {
  manually = 'byDob',
  pointClick = 'byPointClick',
  epic = 'byEpic',
  yardi = 'byYardi',
}

export interface IRegisterMethods {
  type: addedUserByTypeEnum;
  text: string;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  enabled?: boolean;
  isGoToNextStep?: boolean;
}

export interface IOnBoardingPatientRegistrationContext {
  uuid?: string;
  intakeUrl?: string;
  assignPt?: boolean;
  poa?: boolean;
  firstName?: string;
}
export interface IOnBoardingDrawerContextData {
  addedUserByType?: addedUserByTypeEnum;
  patient?: IOnBoardingPatientRegistrationContext;
}

export interface IWizardProviderProps {
  moveToStep: (step: number) => void;
  goBack: (step: number) => void;
  contextData: IOnBoardingDrawerContextData;
  activeStep: number;
  setContextData(data: IOnBoardingDrawerContextData): void;
  goToLastStep: () => void;
}

export interface IRegistrationFlowOption {
  patientDetailesStep: {
    btnText: string;
    headerText: string;
    bodyTexts: string[];
    mixpanelEventName?: string;
  };
}

export interface IRegistrationStep {
  label: string;
  Component: React.ComponentType;
  isAllow: boolean;
  isBackHidden?: boolean;
  isBackDisabled?: boolean;
  isCancelHidden?: boolean;
  btnClassName?: string;
  completed?: boolean;
  headerTooltip?: string;
  className?: string;
}
